import Decimal from 'decimal.js';
import { formatAsCurrency } from '../../../../../../utils/number/numberHelper';

export function getBienniumMonthlySystemCost(totalCost: number, decimalPlaces: number = 0): number {
  return new Decimal(totalCost)
    .div(24)
    .toDecimalPlaces(decimalPlaces)
    .toNumber();
}

export function getBienniumSystemSavings(
  billSavingsForPeriod: number,
  decimalPlaces: number = 0
): number {
  return new Decimal(billSavingsForPeriod)
    .times(8)
    .toDecimalPlaces(decimalPlaces)
    .toNumber();
}

export function getFormattedTotalSystemCost(totalCost: number): string {
  return formatAsCurrency(totalCost).replace('.00', '');
}
